import { render, staticRenderFns } from "./blogpost.vue?vue&type=template&id=37641580&scoped=true&"
import script from "./blogpost.vue?vue&type=script&lang=js&"
export * from "./blogpost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37641580",
  null
  
)

export default component.exports